import {
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGIN_REQUEST,
  LOGOUT,
} from "../constants/LoginConstants";
import axios from "axios";
import baseUrl from "../constants/baseUrl";
import * as Sentry from "@sentry/react";

export const referAFriend =
  (email, id, setError, setSuccess, setLoader, setOpenModal) =>
  async (dispatch) => {
    try {
      await axios.get(`${baseUrl}FriendReferralsAPI/${id}?email=${email}`);
      setSuccess(`Referral email has been sent to ${email}`);
      setLoader(false);
      setOpenModal(true);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
      setSuccess("");
      setError("Something went wrong! Please try again later...");
      setLoader(false);
      setOpenModal(true);
    }
  };

// friend referral signup action
// this action is called in Registerwemoovez/:code page
// it redirects to confirm email page
export const referralSignup =
  (loginData, referralCode, setError, history) => async (dispatch) => {
    console.log("signup cred", loginData);
    try {
      dispatch({
        type: LOGIN_REQUEST,
      });
      const { data } = await axios.post(
        `${baseUrl}Auth/signup/?referralCode=${referralCode}`,
        // config,
        loginData
      );
      console.log("signup data from api", data);
      history.push(`/confirmEmail/${data?.email}`);
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
      dispatch({
        type: LOGIN_FAIL,
        payload: "Signup Failed,Please try again!",
      });
      setError("Signup Failed,Please try again!");
    }
  };
